export default "__VITE_ASSET__C5M7ud8Y__"